import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import * as RadixSwitch from '@radix-ui/react-switch';
import * as RadixLabel from '@radix-ui/react-label';

// Utils
import bemify from 'utils/bemify';

// Styles
import stylesModule from './styles.module.scss';


const styles = bemify(stylesModule);

const Switch = forwardRef(({
  className = null,
  checked = false,
  disabled = false,
  id = null,
  label = null,
  labelMarginSize = 'default',
  onCheckedChange = () => {},
  ...switchProps
}, ref) => {
  const handleSwitchChange = (value) => {
    onCheckedChange(value);
  };

  return (
    <div className={`${styles.switch}${className ? ` ${className}` : ''}`}>
      <RadixSwitch.Root
        ref={ref}
        checked={checked}
        className={`${styles.switch__element}${
          disabled || !checked ? ` ${styles.switch__element_disabled}` : ''}`}
        disabled={disabled}
        id={id}
        onCheckedChange={handleSwitchChange}
        {...switchProps}
      >
        <RadixSwitch.Thumb>
          <div className={styles.switch__thumb} />
        </RadixSwitch.Thumb>
      </RadixSwitch.Root>
      {label && (
        <RadixLabel.Root
          className={`${
            styles.switch__label}${
            disabled ? ` ${styles.switch__label_disabled}` : ''}${
            labelMarginSize === 'none' ? ` ${styles.switch__label_noMargin}` : ''}`}
          htmlFor={id}
        >
          {label}
        </RadixLabel.Root>
      )}
    </div>
  );
});

Switch.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  labelMarginSize: PropTypes.oneOf(['default', 'none']),
  onCheckedChange: PropTypes.func
};

Switch.displayName = 'Switch';

export default Switch;
